// @material-ui/icons
import Dashboard from "@material-ui/icons/Dashboard";
import Flight from "@material-ui/icons/Flight";
import Settlement from "@material-ui/icons/Style";
import Passenger from "@material-ui/icons/AirlineSeatReclineExtra";
import Report from "@material-ui/icons/Report";
import Reconciliation from "@material-ui/icons/RestorePage";
import WalletReport from "views/WalletReport";
//import Report from "@material-ui/icons/Book";
import Audit from "@material-ui/icons/TrackChanges";
import AirlinesPassengerPage from "views/AirlinesPassenger/Index.jsx";
import AirlinePaymentPage from "views/AirlinePayment/Index.jsx";
import SettlementPage from "views/Settlement/Index.jsx";
import BillablePassengers from "views/BillablePassengers/Index.jsx";
import PSCUtilization from "views/PSCUtilization/Index.jsx";
import Reports from "layouts/recordsLanding/recordsLanding.jsx";
import NotFound from "views/NotFound/Index.jsx";
import PDM from "views/PDM/Index.jsx";
import WalletIcon from "@material-ui/core/SvgIcon/SvgIcon";
import TransitPassengerPage from "views/Transit/Index.jsx";
import StatementOfAccount from "views/StatementOfAccount/Index.jsx";
import OutstandingSettlementPage from "views/OutstandingSettlement/Index.jsx";

const routes = [

    {
        path: "/app/passenger-data",
        sidebarName: "Passenger Data",
        navbarName: "Airline Passenger Data",
        icon: Passenger,
        subMenu: [],
        component: AirlinesPassengerPage
    },
    {
        path: "/app/airline-payment",
        sidebarName: "Airline Payment",
        navbarName: "Airline Payment Report",
        icon: Flight,
        subMenu: [],
        component: AirlinePaymentPage
    },
    {
        path: "/app/psc-settlement",
        sidebarName: " PSC Settlement",
        navbarName: "PSC Settlement",
        icon: Settlement,
        subMenu: [],
        component: SettlementPage
    },
    {
        path: "/app/outstanding-settlement",
        sidebarName: "Outstanding Settlement",
        navbarName: "Outstanding Settlement",
        icon: Settlement,
          subMenu: [],
          component: OutstandingSettlementPage
      },
    {
        path: "/reports-landing",
        sidebarName: "PSC Reports",
        navbarName: "Psc Reports",
        icon: Report,
        component: Reports,
        subMenu: [],

    },
    {
        path: "/app/psc-utilization",
        sidebarName: "PSC Utilization",
        isNotVisible: true,
        navbarName: "PSC Utilization",
        icon: Dashboard,
        component: PSCUtilization,
        subMenu: [],

    },
    {
        path: "/app/billable-passengers",
        sidebarName: "Billable Passengers",
        isNotVisible: true,
        navbarName: "Total Passengers vs Billable Passengers",
        icon: BillablePassengers,
        component: BillablePassengers,
        subMenu: [],

    },
    {
        path: "/app/transit-passenger-report",
        sidebarName: "Transit Passenger",
        isNotVisible: true,
        navbarName: "Transit Passenger",
        icon: Report,
        component: TransitPassengerPage,
        subMenu: [],

    },
    {
        path: "/app/statement-of-account",
        sidebarName: "Account Statement",
        isNotVisible: true,
        navbarName: "Account Statement",
        icon: Reconciliation,
        component: StatementOfAccount,
        subMenu: []
    },
    {
        path: "/app/pdm",
        sidebarName: "PDM",
        navbarName: "PDM",
        icon: Reconciliation,
        component: PDM,
        subMenu: [],

    },
    {
        path: "/app/wallet-report",
        sidebarName: "Airline Wallet Report",
        isNotVisible: true,
        navbarName: "Airline Wallet Report",
        icon: WalletIcon,
        component: WalletReport,
        subMenu: [],

    },
    {
        isNotVisible: true,
        path: "**",
        sidebarName: "Not found",
        navbarName: "Not Found",
        icon: Audit,
        subMenu: [],
        component: NotFound,

    }
    ];

export default routes;



// WEBPACK FOOTER //
// ./src/routes/staff.jsx